"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactUi = require("@100mslive/react-ui");
var _jsxRuntime = require("react/jsx-runtime");
var FullPageProgress = function FullPageProgress() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Flex, {
    justify: "center",
    align: "center",
    css: {
      size: "100%"
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Loading, {
      size: 100
    })
  });
};
var _default = FullPageProgress;
exports["default"] = _default;